import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription";
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import e1 from "@/assets/images/services/expansion joint.jpg"

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 1, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const ExpansionJoints = () => {
  return (
    <>
      <div className="pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
        <TitleBar title="Expansion Joints" />

        <motion.div {...fadeInUp}>
          <ImageWithContentLeft
            imageUrl={e1}
            title="Description"
            content={
              <>
                An <span className="span-text">expansion joint</span> is a structural component designed to absorb movement,
                vibrations, and thermal expansion or contraction in building structures, roads, bridges, and piping systems.
                These joints allow safe and controlled movement caused by temperature changes, seismic activity, or structural
                settling, thereby preventing cracks and other structural damage.
              </>
            }
          />
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Why Expansion Joints Are Important">
            <Paragraph
              content="Without expansion joints, structural elements such as concrete slabs, walls, and pipes can crack or break due to thermal stresses, shrinkage, or mechanical vibrations. Expansion joints maintain the integrity, durability, and longevity of a structure by:"
            />
            <CustomLists
              items={[
                [
                  "Allowing dimensional changes due to temperature variation",
                  "Absorbing vibrations and movement",
                  "Preventing structural damage",
                  "Minimizing the impact of seismic events",
                  "Ensuring waterproofing continuity between structural elements",
                ],
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Applications of Expansion Joints">
            <CustomLists
              items={[
                ["High-rise buildings", "Parking decks", "Bridge decks and expansion gaps", "Podiums and terraces"],
                ["Industrial floors and warehouses", "Airport runways", "Water retaining structures like tanks and reservoirs"],
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Types of Expansion Joints">
            <ListWithDescription
              layout="split"
              titleListType="disc"
              items={[
                {
                  title: "Concrete Expansion Joints",
                  content: ["Used in buildings, bridges, and sidewalks to prevent cracking due to shrinkage or temperature changes."],
                },
                {
                  title: "Bridge Expansion Joints",
                  content: ["Designed to accommodate movement between bridge sections. These can be modular, strip seal, or finger joints."],
                },
                {
                  title: "Building Expansion Joints",
                  content: ["Installed in high-rise buildings and industrial structures to manage vertical and horizontal movement."],
                },
                {
                  title: "Floor Expansion Joints",
                  content: ["Installed in large floors and industrial areas where slabs undergo shrinkage and thermal changes."],
                },
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Advantages">
            <CustomLists
              items={[
                [
                  'Excellent quality plugging compound-consistent performance.',
                  'High early strength —plugging is completed within 5 minutes',
                  'Simple Application', 'Excellent adhesion'
                ],
                [
                  'Water repellent concrete',
                  'Prevents/reduce sweating, efflorescence saltpetre action',
                  'Arrest shrinkage, better finish',
                  'Very economical, required at very lesser dosage'
                ]
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Installation Process">
            <ListWithDescription
              layout="stacked"
              titleListType="decimal"
              items={[
                {
                  title: "Surface Preparation",
                  content: ["Clean the joint area to remove dust, debris, or oil."],
                },
                {
                  title: "Joint Sizing",
                  content: ["Measure and cut the joint filler to match the gap."],
                },
                {
                  title: "Placement of Joint Filler",
                  content: ["Place pre-molded filler (bitumen board, foam) in the joint space."],
                },
                {
                  title: "Sealant Application",
                  content: ["Apply a high-performance joint sealant (PU or polysulphide) over the filler to ensure water tightness."],
                },
                {
                  title: "Protection Layer (if needed)",
                  content: ["Install a metal capping or waterproofing membrane over the joint in exposed areas."],
                },
              ]}
            />
          </TitleWithContent>
        </motion.div>
        
        <motion.div {...fadeInUp}>
        <TitleWithContent title='Why Choose Us for Expansion Joints?'>
            <Paragraph
            content={
                <>
                At <span className="span-text">Sheel Waterproofing</span>, we provide expert installation and maintenance of expansion joints that ensure the durability and flexibility of your structures. Our solutions are perfect for high-rise buildings, bridges, industrial floors, and more. We focus on delivering reliable, cost-effective solutions with the following benefits:
                </>
            }
            />
            <CustomLists
            listStyle="none"
            layout="stacked"
            items={[[ 
                'Prevents structural cracking due to temperature variation, seismic activity, and settling',
                'Ensures continuous waterproofing between structural elements',
                'Provides long-term durability, minimizing the need for maintenance',
                'Easy to install with minimal disruption to ongoing operations',
            ]]}
            bullets={[["🏢", "🌍", "🔧", "💪"]]}
            />
            <Paragraph
            content={
                <>
                Our expansion joints are designed to provide seamless protection and adaptability in any structure. With <span className="span-text">Sheel Waterproofing</span>, you are guaranteed high-quality, lasting solutions that ensure the safety and integrity of your property.
                <br /><br />
                <a href="/contact" className="text-custom-hov underline">Contact us today</a> for a free consultation or site inspection.
                </>
            }
            />
        </TitleWithContent>
        </motion.div>

      </div>
    </>
  );
};

export default ExpansionJoints;
